<template>
	<div class="m-l-50 m-t-0 w-1200">
		<el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-form-item label="工具名称" prop="name">
        <el-input v-model.trim="form.name" placeholder="请输入工具名称" class="h-40 w-300"></el-input>
      </el-form-item>
      <el-form-item label="工具地址" prop="url">
        <el-input v-model.trim="form.url" placeholder="请输入工具地址" class="h-40 w-300"></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input v-model.trim="form.remark" placeholder="请输入备注" class="h-40 w-300"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add()" :loading="isLoading" size="small">保 存</el-button>
        <el-button @click="goback()" size="small">返 回</el-button>
      </el-form-item>
		</el-form>
	</div>
</template>
<style>
	.form-checkbox:first-child{
		margin-left: 15px;
	}
  .item {
    margin: 4px;
  }
</style>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'
  export default {
    data() {
      return {
        isLoading: false,
        id: null,
        form: {
          name: '',
          url: '',
          remark: ''
        },
        rules: {
          name: [
            { required: true, message: '请输入工具名' }
          ],
          url: [
            { required: true, message: '请输入地址' }
          ]
        }
      }
    },
    methods: {
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPut('admin/development/', this.id, this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '保存成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      async getCompleteData() {
        this.apiGet('admin/development/' + this.id).then((res) => {
          this.handelResponse(res, (data) => {
            this.form.name = data.name
            this.form.url = data.url
            this.form.remark = data.remark
          })
        })
      }
    },
    created() {
      this.id = this.$route.params.id
      this.getCompleteData()
    },
    components: {
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// edit.vue?16922935